import { render, staticRenderFns } from "./Couponlist.vue?vue&type=template&id=14f8fd91&scoped=true&"
import script from "./Couponlist.vue?vue&type=script&lang=js&"
export * from "./Couponlist.vue?vue&type=script&lang=js&"
import style0 from "./Couponlist.vue?vue&type=style&index=0&id=14f8fd91&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f8fd91",
  null
  
)

export default component.exports